import './CustomFields.scoped.scss'
import ActivateWidget from './Widgets/ActivateWidget'
import DonationsWidget from './Widgets/DonationsWidget'
import RegularDonationsWidget from './Widgets/RegularDonationsWidget'
import VerifyLinkWidget from './Widgets/VerifyLinkWidget'
import MembershipCardWidget from './Widgets/MembershipCardWidget'
import NotesWidget from './Widgets/NotesWidget'
import Boxes from 'Shared/components/Boxes'

const WIDGETS = {
  activate: <ActivateWidget />,
  donations: <DonationsWidget />,
  regularDonations: <RegularDonationsWidget />,
  verify: <VerifyLinkWidget />,
  membership_card: <MembershipCardWidget />,
  notes: <NotesWidget />,
}

const Widgets = ({ widgets }) => {
  return (
    <>
      {widgets.map((widget) => (
        <Boxes
          id={widget}
          sizes={['full-width']}
          boxes={[WIDGETS[widget]]}
          containerClass={'gutter-bottom'}
        />
      ))}
    </>
  )
}

export default Widgets
